export default {
    titulo: "Spare Parts",
    nuevo: "New spare part",
    editar: "Edit spare part",
    buscar: "Search by part number, barcode or description",
    eliminar: "Delete spare part",
    pregEliminar: "Are you sure you want to delete the spare part?",
    cantidad: "Quantity",
    msgStock: "No stock available",
    nroSerie: "Serial number",
    textAplicaNumSerie: "When buying the spare part, request serial numbers",
    precio1: "Sale price 1",
    precio2: "Sale price 2",
    stockMinimo: "Minimum stock",
    impuesto: "Tax",
    stockPorSucursal: "Spare parts stock per branch",
    familias: "Families",
    nuevaFamilia: "New family",
    editarFamilia: "Edit family",
    eliminarFamilia: "Delete family",
    pregEliminarFamilia: "Are you sure you want to delete the family?"
}
